import { render } from "./PigsStatusGraph.vue?vue&type=template&id=b1ed0838&ts=true"
import script from "./PigsStatusGraph.vue?vue&type=script&lang=ts"
export * from "./PigsStatusGraph.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__